import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TreeTableComponent } from 'src/app/components/tree-table/tree-table.component';
import { alphabetWithSpaces } from 'src/app/functions/validation-functions';
import { TreeNode } from 'src/app/models/MenuData';
import { MenuService } from 'src/app/services/menu.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-roles-create',
  templateUrl: './roles-create.component.html',
  styleUrls: ['./roles-create.component.css']
})
export class RolesCreateComponent {
  selectedIds:number[]=[];
  nodes: TreeNode[] =[];
  activeTab:number=1;
  roleForm: FormGroup;
  submittedRoleForm:boolean=false;
  submittedPermissionForm:boolean=false;
  permissions: TreeNode[] = [];
  menuId:number = 0;
	menuUrl : string = "";
  canEdit : boolean = false;
  //rolePermission:RolePermission[]=[];
  isButtonDisabled:boolean = false;
  @ViewChild(TreeTableComponent) treeTableComponent : TreeTableComponent | undefined;
  //getSelectedIds()
  constructor(private fb: FormBuilder,private menuService: MenuService,private router:Router
    // ,private activatedRoute:ActivatedRoute
    ) {

      let obj = this.router.getCurrentNavigation()?.extras?.state;
      if(obj)
      {
        this.menuId = parseInt(obj['menuId'])??0;
        this.menuUrl = obj['menuUrl'];
        this.canEdit = obj['canEdit'];
      }

      this.getFormData(0);
      this.roleForm = this.fb.group({
        "roleId": ['0', [Validators.required]],
        "roleName": ['', [Validators.required]],
        "roleDescription": ['', [Validators.required]],
        "userMenus":[]
      });
    }

  get roleFormControl() {
    return this.roleForm.controls;
  }

  changeTab(tab:number)
  {
    this.activeTab = tab;
  }

  async saveNext(tab:number,isPrevious:boolean = false)
  {    
    if(tab == 2 && isPrevious == false)
    {
      this.submittedRoleForm = true;
        if(this.roleForm.valid)
        {
          this.activeTab = tab;
        }      
    }
    else
    {
      this.activeTab = tab;
    }
  }

  async getFormData(id:number)
  {
    const res = await this.menuService.GetRolesPermissionById(id)??undefined;
      if (res != null && res.result) {
        this.roleForm.patchValue(res.result);    
        let userMenus =  res.result.userMenus;   
        this.permissions = JSON.parse(JSON.stringify(userMenus));
        for(var i=0; i<this.permissions.length; i++) { // add childs to every item
          this.permissions[i].children = [];
        }
        let tempSe = JSON.parse(JSON.stringify(this.permissions));
        this.selectedIds =tempSe.filter((f:any)=>{return f.isSelected == true}).map((m:any)=>{return m.menuId});
        this.buildTree(this.permissions,undefined);
        this.nodes = this.permissions;
      } 
  }
  ngOnInit()
  { 
    
  }
  buildTree(tree:TreeNode[], item:any) {
    if (item) { // if item then have parent
        for (var i=0; i<tree.length; i++) { // parses the entire tree in order to find the parent
            tree[i].collapsed = !tree[i].isSelected;
            if (String(tree[i].menuId) === String(item.menuAuthorityId)) { // bingo!
                item.collapsed = !item.isSelected;
                tree[i].children.push(item); // add the child to his parent
                break;
            }
            else this.buildTree(tree[i].children, item); // if item doesn't match but tree have childs then parses childs again to find item parent
        }
    }
    else { // if no item then is a root item, multiple root items are supported
        var idx = 0;
        while (idx < tree.length)
            if (tree[idx].menuAuthorityId != 0) 
            this.buildTree(tree, tree.splice(idx, 1)[0]) // if have parent then remove it from the array to relocate it to the right place
            else idx++; // if doesn't have parent then is root and move it to the next object
        }
    }

    alphabetOnly(event:any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
        return true;
      }
      return false;
    }
  
    alphabetWithSpaces(event:any){
      return alphabetWithSpaces(event);
    }

    alphaNumericOnly(event:any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32))) {
        return true;
      }
      return false;
    }

    async saveData(){
      if(this.roleForm.valid)
      {
        this.isButtonDisabled = true;
        setTimeout(() => {
          this.isButtonDisabled = false;
        }, 3000);
        this.roleFormControl['userMenus'].setValue(this.roleFormControl['userMenus'].value.map((m:any)=>{return {...m, isSelected: this.selectedIds.includes(m.menuId) ? true : false}}));
        let res = await this.menuService.SaveUpdateRoleWithPermission(this.roleForm.value);
        if (res != null) {
          swal.fire({
            position: 'center',
            icon:  res.isSuccess ?'success' : 'error',
            title: res.result,
            showConfirmButton: false,
            timer: 3000,
          });
        }

        if(res?.isSuccess)
        {
          this.homeBtClick();
        }
      }
    }

    onCheckChanged(selectedIDs: any) {
      this.selectedIds = selectedIDs;
    }

    homeBtClick(){
      this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
    }
}
